import { Link } from "react-router-dom";

export default function FormNotice({ className = "" }) {
    return (
        <p className={`text-xs leading-relaxed text-[#8a8a95] ${className}`}>
            Sending this opens your email app. We use what you send only to reply.{" "}
            <Link to="/privacy" className="font-semibold text-[#0a0a0b] underline underline-offset-4">
                Privacy
            </Link>
            {" · "}
            <Link to="/terms" className="font-semibold text-[#0a0a0b] underline underline-offset-4">
                Terms
            </Link>
        </p>
    );
}
